export default __webpack_public_path__ + "static/media/zoom-contributions.155ab248.md";